import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_USERS = 'GET_USERS';
export const LOCK_USER = 'LOCK_USER';

export const actions = createSagaActionTypes('TELEPHONY_USERS', [
  GET_USERS,
  LOCK_USER
]);
